export default "__VITE_ASSET__f974845c__"